/** Build a tree of folders scoped to a single opposition. */
export function buildFolderTree(folders, materials, oppositionId) {
    const scoped = folders.filter((f) => f.opposition_id === oppositionId);
    const fileCounts = new Map();
    for (const m of materials) {
        if (m.opposition_id !== oppositionId)
            continue;
        fileCounts.set(m.folder_id, (fileCounts.get(m.folder_id) ?? 0) + 1);
    }
    const byId = new Map();
    for (const f of scoped) {
        byId.set(f.id, {
            folder: f,
            children: [],
            fileCount: fileCounts.get(f.id) ?? 0,
            totalFileCount: 0,
            childCount: 0,
        });
    }
    const roots = [];
    for (const node of byId.values()) {
        if (node.folder.parent_id) {
            const parent = byId.get(node.folder.parent_id);
            if (parent)
                parent.children.push(node);
            else
                roots.push(node);
        }
        else {
            roots.push(node);
        }
    }
    const sortChildren = (nodes) => {
        nodes.sort((a, b) => {
            if (a.folder.order !== b.folder.order)
                return a.folder.order - b.folder.order;
            return a.folder.name.localeCompare(b.folder.name, 'es', { numeric: true });
        });
        for (const n of nodes)
            sortChildren(n.children);
    };
    sortChildren(roots);
    // Compute total file count + child count.
    function recompute(node) {
        node.childCount = node.children.length;
        let total = node.fileCount;
        for (const c of node.children)
            total += recompute(c);
        node.totalFileCount = total;
        return total;
    }
    for (const r of roots)
        recompute(r);
    return roots;
}
export function indexFolders(folders) {
    const m = new Map();
    for (const f of folders)
        m.set(f.id, f);
    return m;
}
/** Returns the chain of folders from root to `folderId`, inclusive. */
export function getAncestors(folderId, index) {
    const chain = [];
    let cur = folderId ? index.get(folderId) ?? null : null;
    while (cur) {
        chain.unshift(cur);
        cur = cur.parent_id ? index.get(cur.parent_id) ?? null : null;
    }
    return chain;
}
/** Materials whose folder_id matches the requested folder. */
export function filesInFolder(materials, folderId) {
    return materials
        .filter((m) => m.folder_id === folderId)
        .sort((a, b) => {
        if (a.order !== b.order)
            return a.order - b.order;
        return a.name.localeCompare(b.name, 'es', { numeric: true });
    });
}
/** Returns true if `candidateAncestor` is an ancestor of `descendantId` (or the same). */
export function isDescendantOrSame(candidateAncestorId, descendantId, index) {
    let cur = index.get(descendantId) ?? null;
    while (cur) {
        if (cur.id === candidateAncestorId)
            return true;
        cur = cur.parent_id ? index.get(cur.parent_id) ?? null : null;
    }
    return false;
}
/** Build a human-readable folder path. */
export function folderPathLabel(folderId, index, separator = ' › ') {
    const chain = getAncestors(folderId, index);
    return chain.map((f) => f.name).join(separator);
}
//# sourceMappingURL=tree.js.map